var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((Object.entries(_vm.items)),function(ref){
var key = ref[0];
var value = ref[1];
return (_vm.shouldShow(value))?_c('div',{staticClass:"col-3 mb-3"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getLabel(key))+": ")]),_c('span',[(_vm.isPrice(key))?[_vm._v(" "+_vm._s(_vm._f("price")(value))+" ")]:[_vm._v(_vm._s(value))],_vm._v(" "+_vm._s(_vm.getAfterLabel(key)))],2)]):_vm._e()}),0)}
var staticRenderFns = []

export { render, staticRenderFns }